import { Component } from '@angular/core';

@Component({
  selector: 'DCO-unauthorized',
  templateUrl: './unauthorized.component.html',
  standalone: false,
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent {

}
